module.exports = __webpack_public_path__ + "static/media/cost-effective.819d007f.svg";